(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["taxonomy-subcollections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('taxonomy-subcollections')) {
    class TaxonomySubcollections extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.toggleButton = this.querySelector('[data-taxonomy-toggle]');
        this.panel = this.querySelector('[data-taxonomy-panel]');
        this.rail = this.querySelector('[data-taxonomy-rail]');
        this.navigation = this.querySelector('.taxonomy-subcollections__navigation');
        this.row = this.querySelector('.taxonomy-subcollections__row');

        if (!this.toggleButton || !this.panel || !this.rail || !this.navigation || !this.row) return;

        this.handleToggle = () => this.togglePanel();
        this.handleScroll = () => this.updateOverflowState();
        this.handleResize = () => this.updateOverflowState();
        this.handleToolbarMutation = () => {
          cancelAnimationFrame(this.toolbarMountFrame);
          this.toolbarMountFrame = requestAnimationFrame(() => this.mountToolbarToggles());
        };
        this.toggleButton.addEventListener('click', this.handleToggle);
        this.navigation.addEventListener('scroll', this.handleScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.handleResize);
          this.resizeObserver.observe(this.navigation);
          this.resizeObserver.observe(this.row);
        } else {
          window.addEventListener('resize', this.handleResize);
        }

        this.toolbarObserver = new MutationObserver(this.handleToolbarMutation);
        this.observeToolbarRoot(document.body);
        this.mountToolbarToggles();

        requestAnimationFrame(() => {
          this.handleResize();
          this.revealCurrentItem();
        });
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.handleToggle);
        this.navigation?.removeEventListener('scroll', this.handleScroll);
        this.resizeObserver?.disconnect();
        this.toolbarObserver?.disconnect();
        cancelAnimationFrame(this.toolbarMountFrame);
        this.getToolbarToggles().forEach((button) => button.remove());
        window.removeEventListener('resize', this.handleResize);
      }

      togglePanel() {
        const willExpand = this.panel.hidden;

        this.panel.hidden = !willExpand;
        this.syncExpandedState(willExpand);

        if (willExpand) {
          requestAnimationFrame(() => {
            this.handleResize();
            this.revealCurrentItem();
          });
        }
      }

      syncExpandedState(isExpanded) {
        this.toggleButton.setAttribute('aria-expanded', String(isExpanded));
        this.getToolbarToggles().forEach((button) => {
          button.setAttribute('aria-expanded', String(isExpanded));
        });
      }

      createToolbarToggle(kind) {
        const button = document.createElement('button');
        const fullLabel = document.createElement('span');
        const compactLabel = document.createElement('span');
        const chevron = this.querySelector('.taxonomy-subcollections__chevron')?.cloneNode(true);

        button.type = 'button';
        button.className = `taxonomy-toolbar-toggle taxonomy-toolbar-toggle--${kind}`;
        button.dataset.taxonomyToolbarToggle = this.panel.id;
        button.setAttribute('aria-controls', this.panel.id);

        fullLabel.className = 'taxonomy-toolbar-toggle__label taxonomy-toolbar-toggle__label--full';
        fullLabel.textContent = this.dataset.desktopLabel;
        compactLabel.className = 'taxonomy-toolbar-toggle__label taxonomy-toolbar-toggle__label--compact';
        compactLabel.textContent = this.dataset.compactLabel;

        button.append(fullLabel, compactLabel);
        if (chevron) button.append(chevron);
        button.addEventListener('click', this.handleToggle);

        return button;
      }

      getToolbarToggles() {
        return Array.from(document.querySelectorAll('[data-taxonomy-toolbar-toggle]')).filter(
          (button) => button.dataset.taxonomyToolbarToggle === this.panel.id
        );
      }

      observeToolbarRoot(root) {
        if (!root || root === this.toolbarObserverTarget) return;

        this.toolbarObserver.disconnect();
        this.toolbarObserver.observe(root, { childList: true, subtree: true });
        this.toolbarObserverTarget = root;
      }

      mountToolbarToggles() {
        const toolbarTargets = [
          {
            kind: 'desktop',
            host: document.querySelector(
              '.product-grid-container .facets.facets--horizontal.facets-controls-wrapper'
            ),
          },
          {
            kind: 'mobile',
            host: document.querySelector('.product-grid-container .facets-toggle'),
          },
        ];

        toolbarTargets.forEach(({ kind, host }) => {
          if (!host) return;

          const existingToggle = Array.from(
            host.querySelectorAll('[data-taxonomy-toolbar-toggle]')
          ).find((button) => button.dataset.taxonomyToolbarToggle === this.panel.id);

          if (!existingToggle) host.append(this.createToolbarToggle(kind));
        });

        if (this.getToolbarToggles().length > 0) {
          this.dataset.toolbarEnhanced = 'true';
          this.syncExpandedState(!this.panel.hidden);
          this.observeToolbarRoot(
            document.querySelector('results-list.product-grid-container') || document.body
          );
        }
      }

      updateOverflowState() {
        const isOverflowing = this.navigation.scrollWidth > this.navigation.clientWidth + 2;
        const isAtEnd =
          this.navigation.scrollLeft + this.navigation.clientWidth >= this.navigation.scrollWidth - 2;

        this.rail.dataset.overflowing = String(isOverflowing);
        this.rail.dataset.atEnd = String(isAtEnd);
      }

      revealCurrentItem() {
        const currentItem = this.querySelector('[aria-current="page"]')?.closest('.taxonomy-subcollections__item');
        if (!currentItem || this.navigation.scrollWidth <= this.navigation.clientWidth + 2) return;

        const visibleStart = this.navigation.scrollLeft + 2;
        const visibleEnd = this.navigation.scrollLeft + this.navigation.clientWidth - 2;
        const itemStart = currentItem.offsetLeft;
        const itemEnd = itemStart + currentItem.offsetWidth;

        if (itemStart >= visibleStart && itemEnd <= visibleEnd) return;

        const maxScroll = this.navigation.scrollWidth - this.navigation.clientWidth;
        const centeredScroll = itemStart - (this.navigation.clientWidth - currentItem.offsetWidth) / 2;
        const targetScroll = Math.max(0, Math.min(centeredScroll, maxScroll));
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.navigation.scrollTo({
          left: targetScroll,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }
    }

    customElements.define('taxonomy-subcollections', TaxonomySubcollections);
  }

  } catch(e) { console.error(e); }
})();
})();
